<template>
    <div v-if="user">
        <loading-spinner v-if="loading"/>
        <v-row v-else>
            <v-col cols="12" class="title-heavy">
                Ordenes emitidas
                <v-divider class="divider-secondary mt-2"/>
            </v-col>
            <v-col cols="12" class="body-light" v-if="orders.length === 0">
                Aún no posees ordenes a mostrar
            </v-col>
            <v-col cols="12" v-for="order in orders" :key="order.code">
                <order-card @click:view="onViewOrder(order)" :order="order" class="pb-2"/>
            </v-col>
        </v-row>

        <!-- ORDER DIALOG -->
        <order-dialog :current-order="currentOrder" :user="user" with-message ref="orderView"/>
    </div>
</template>

<script>
import LoadingSpinner from "@/components/common/LoadingSpinner";
import OrderCard from "@/components/cards/OrderCard";
import OrderDialog from "@/components/orders/OrderDialog";
import httpService from "@/services/httpService";

export default {
    name: "ClientBoughtInfo",
    components: {OrderDialog, OrderCard, LoadingSpinner},
    props: {
        user: {
            type: Object,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            loading: false,
            emissionOptions: [],

            orders: [],
            order: null,

            examsPerPage: 21,
        }
    },
    computed: {
        currentOrder(vm = this) {
            if (!vm.order) return []
            let orders = []
            vm.emissionOptions.forEach(emission => {
                let exams = vm.order.exams.filter(ex => ex.emission.name === emission.name)
                if (exams.length > 0) {
                    if(exams.length / vm.examsPerPage > 1) {
                        for (let i = 0; i < exams.length; i += vm.examsPerPage) {
                            const currentExams = exams.slice(i, i + vm.examsPerPage);
                            orders.push({
                                id: vm.order.id,
                                created_at: vm.order.created_at,
                                title: emission.name,
                                exams: currentExams
                            })
                        }
                    } else {
                        orders.push({
                            id: vm.order.id,
                            created_at: vm.order.created_at,
                            title: emission.name,
                            exams: exams
                        })
                    }
                }
            })
            orders.id = vm.order?.id || null
            orders.laboratory = vm.order?.laboratory || null
            orders.isCompany = !!vm.order?.company_id || false
            return orders
        },
    },
    async mounted() {
        const vm = this
        await vm.loadEmissions()
        await vm.loadHomeClient()
    },
    methods: {
        async loadEmissions() {
            const vm = this
            let response = await httpService.get('emissions')
            vm.emissionOptions = response.data.emissions
        },
        async loadHomeClient() {
            const vm = this
            if (!vm.user) return;
            vm.loading = true
            let response = await httpService.get(`users/${vm.user.id}/home`)
            // console.log('response loadHomeClient', response)
            vm.orders = response.data.orders
            vm.loading = false
        },
        onViewOrder(order) {
            const vm = this
            console.log('order',order)
            vm.order = {...order}
            vm.$refs.orderView.show()
        },
    },
    watch: {
        user() {
            this.loadHomeClient()
        },
    }
}
</script>

<style scoped>

</style>